import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

// Wording shared by the tooltip and the badge's accessible name, so keyboard
// and screen-reader users get the same explanation pointer users get.
const HIDDEN_EXPLANATION =
  "Not on the website right now — featuring it has no effect until the branch runs a class or turns on call-to-enroll.";

// Every regular stream the branch offers that is not already featured. Adding
// appends to the end of the strip, so the manager reorders afterwards.
export function AvailableCoursesTable({
  courses,
  atCap,
  atCapMessageId,
  disabled,
  onAdd,
}) {
  return (
    <Table size="small" aria-label="Available streams">
      <TableHead>
        <TableRow>
          <TableCell>Stream</TableCell>
          <TableCell>Description</TableCell>
          <TableCell align="center" style={{ width: "150px" }}>
            On the website
          </TableCell>
          <TableCell align="center" style={{ width: "110px" }}>
            Feature
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {courses.length === 0 ? (
          <TableRow>
            <TableCell colSpan={4} align="center">
              <p className="text-muted my-3">No streams match this search.</p>
            </TableCell>
          </TableRow>
        ) : (
          courses.map((course) => (
            <TableRow key={course.branch_course_id}>
              <TableCell>
                <span className="font-weight-bolder d-block">
                  {course.course_name}
                </span>
                <span className="text-muted font-size-sm">
                  {course.course_code}
                </span>
              </TableCell>
              <TableCell
                style={{
                  maxWidth: "420px",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                <span className="text-muted">{course.short_description}</span>
              </TableCell>
              <TableCell align="center">
                {Number(course.publicly_visible) === 1 ? (
                  <span className="label label-inline label-light-success">
                    Showing
                  </span>
                ) : (
                  <OverlayTrigger
                    overlay={
                      <Tooltip id={`available-${course.branch_course_id}`}>
                        {HIDDEN_EXPLANATION}
                      </Tooltip>
                    }
                  >
                    {/* Focusable so the tooltip opens on keyboard focus, and
                        labelled so the reason is announced either way. */}
                    <span
                      className="label label-inline label-light-warning"
                      tabIndex={0}
                      role="note"
                      aria-label={`Hidden. ${HIDDEN_EXPLANATION}`}
                    >
                      Hidden
                    </span>
                  </OverlayTrigger>
                )}
              </TableCell>
              <TableCell align="center">
                <button
                  type="button"
                  className="btn btn-light-primary btn-sm font-weight-bold"
                  disabled={disabled || atCap}
                  aria-describedby={atCap ? atCapMessageId : undefined}
                  title={
                    atCap
                      ? "Remove one of the featured streams first"
                      : "Add to the featured strip"
                  }
                  onClick={() => onAdd(course.branch_course_id)}
                >
                  Feature
                </button>
              </TableCell>
            </TableRow>
          ))
        )}
      </TableBody>
    </Table>
  );
}
